export const APPS_PAGE_TRANSLATION_KEYS = {
    title: 'title',
    description: 'description',
    openApp: 'openApp',
    noAssigned: 'noAssigned',
    card: {
        orionDescription: 'card.orionDescription',
        resmedOnlineStoreDescription: 'card.resmedOnlineStoreDescription'
    },
    emptyState: {
        bannerTitle: 'emptyState.bannerTitle',
        bannerMessage: 'emptyState.bannerMessage',
        supportIntro: 'emptyState.supportIntro',
        supportHeading: 'emptyState.supportHeading',
        supportHours: 'emptyState.supportHours',
        supportCountries: 'emptyState.supportCountries',
        supportLanguages: 'emptyState.supportLanguages'
    }
};
